var map = {
	"./All_Consoles 2.png": 6895,
	"./All_Consoles.png": 1437,
	"./All_Games 2.png": 4964,
	"./All_Games.png": 6718,
	"./Atari_2600.png": 8557,
	"./Microsoft_Xbox.png": 1079,
	"./Microsoft_Xbox_360.png": 6291,
	"./Microsoft_Xbox_One.png": 9378,
	"./Most_Wanted.png": 7894,
	"./NEC_PC_Engine.png": 7192,
	"./NEC_PC_Engine_CD.png": 2652,
	"./Nintendo_3DS.png": 2017,
	"./Nintendo_64.png": 3535,
	"./Nintendo_DS.png": 6350,
	"./Nintendo_Entertainment_System.png": 5559,
	"./Nintendo_Famicom_Disk_System.png": 3933,
	"./Nintendo_GameCube.png": 6248,
	"./Nintendo_Game_Boy.png": 6208,
	"./Nintendo_Game_Boy_Advance.png": 2495,
	"./Nintendo_Game_Boy_Color.png": 4972,
	"./Nintendo_Pokemon_Mini.png": 4186,
	"./Nintendo_Switch.png": 8057,
	"./Nintendo_Switch_2.png": 2594,
	"./Nintendo_Virtual_Boy.png": 3283,
	"./Nintendo_Wii.png": 6244,
	"./Nintendo_Wii_U.png": 2464,
	"./PC_Engine_CD.png": 6805,
	"./SNK_Neo_Geo_CD.png": 7000,
	"./SNK_Neo_Geo_Pocket_Color.png": 6855,
	"./Sega_32X.png": 4715,
	"./Sega_CD.png": 6269,
	"./Sega_Dreamcast.png": 8218,
	"./Sega_Game_Gear.png": 8866,
	"./Sega_Genesis.png": 7528,
	"./Sega_Master_System.png": 9460,
	"./Sega_SG-1000.png": 7006,
	"./Sega_Saturn.png": 305,
	"./Sony_PSP.png": 490,
	"./Sony_Playstation.png": 9353,
	"./Sony_Playstation_2.png": 5586,
	"./Sony_Playstation_3.png": 6715,
	"./Sony_Playstation_4.png": 6804,
	"./Sony_Playstation_5.png": 9837,
	"./Sony_Playstation_Vita.png": 8120,
	"./Soundtracks.png": 1222,
	"./Super_Nintendo_Entertainment_System.png": 483,
	"./WonderSwan.png": 1609,
	"./WonderSwan_Color.png": 989,
	"./default.png": 1132,
	"./favorites.png": 9348,
	"./stats.png": 1274
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9240;